import React, { useState } from "react";
import api, { formatApiError } from "@/lib/api";

export const STATUS_STYLES = {
  requested: "bg-[#2E1E1E] text-[#E58B5E] border border-[#E58B5E]/40",
  confirmed: "bg-[#C93B3B] text-white",
  completed: "bg-[#1F1717] text-[#F7ECEB] border border-[#382A2A]",
  declined: "bg-[#110D0D] text-[#A89896]",
  cancelled: "bg-[#110D0D] text-[#A89896]",
  expired: "bg-[#110D0D] text-[#A89896]",
  pending_payment: "bg-[#110D0D] text-[#A89896]",
};

export const STATUS_LABELS = {
  requested: "Awaiting practitioner",
  confirmed: "Confirmed",
  completed: "Completed",
  declined: "Declined",
  cancelled: "Cancelled",
  expired: "Expired",
  pending_payment: "Payment pending",
};

export const StatusBadge = ({ status }) => (
  <span className={`text-xs uppercase tracking-[0.2em] px-3 py-1 rounded-full inline-block ${STATUS_STYLES[status] || STATUS_STYLES.pending_payment}`}
    data-testid={`status-${status}`}>
    {STATUS_LABELS[status] || status}
  </span>
);

const TIME_OPTIONS = ["09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00", "18:00", "19:00", "20:00"];

export const RescheduleForm = ({ booking, onDone, onCancel }) => {
  const [date, setDate] = useState(booking.date);
  const [slot, setSlot] = useState(booking.time_slot);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setErr(""); setBusy(true);
    try {
      await api.post(`/bookings/${booking.id}/reschedule`, { date, time_slot: slot });
      onDone();
    } catch (e) { setErr(formatApiError(e.response?.data?.detail) || "Could not reschedule"); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-4 p-4 rounded-xl bg-[#110D0D] border border-[#382A2A]" data-testid={`reschedule-form-${booking.id}`}>
      <div className="text-xs uppercase tracking-[0.2em] text-[#E58B5E] mb-3">Reschedule</div>
      <div className="grid sm:grid-cols-2 gap-3">
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid="reschedule-date"
          className="px-3 py-2 rounded-lg border border-[#382A2A] bg-[#1F1717] text-[#F7ECEB]" />
        <select value={slot} onChange={(e) => setSlot(e.target.value)} data-testid="reschedule-slot"
          className="px-3 py-2 rounded-lg border border-[#382A2A] bg-[#1F1717] text-[#F7ECEB]">
          {TIME_OPTIONS.map((t) => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>
      {err && <div className="text-sm text-[#E58B5E] mt-3" data-testid="reschedule-error">{err}</div>}
      <div className="flex gap-2 mt-3">
        <button onClick={submit} disabled={busy} className="btn-primary text-sm" data-testid="reschedule-submit">{busy ? "Saving..." : "Save new time"}</button>
        <button onClick={onCancel} className="btn-ghost text-sm">Back</button>
      </div>
    </div>
  );
};
